/**
 * PageNavigationController
 *
 * @author Stefan Lamm <stefan.lamm@pluswerk.ag>
 */
Pluswerk.PlusProject.Navigation.PageNavigationController = function () {
  $('.js-back').on('click', function () {
    if (document.referrer.split('/')[2] === window.location.host) {
      if (document.referrer.indexOf(window.location.host) !== -1) {
        history.back();
        return false;
      }
    }
    return true;
  });
};
